import {
  EDIT_SURVEY,
  LIST_SURVEY,
  FINAL_SUBMISSION_QUESTIONS_ANSWERS,
  SURVEY_SUCCESS,
  SURVEY_ERROR,
  MAIL_INVITE,
  SAVE_QUESTION_ANSWER,
  GET_QUESTION,
  QUESTION_ERROR,
  QUESTION_SUCCESS,
  LIST_HORIZONTAL,
  LIST_VERTICAL,
  HORIZONTAL_SUCCESS,
  HORIZONTAL_ERROR,
  VERTICAL_SUCCESS,
  VERTICAL_ERROR
} from "./actionTypes"

// Save Question
export const saveQuestionAnswer = (data, type, callback) => {
  return {
    type: SAVE_QUESTION_ANSWER,
    payload: { data, type, callback },
  }
}

export const finalSubmissionQuestionAnswers = (data, type, callback) => {
  return {
    type: FINAL_SUBMISSION_QUESTIONS_ANSWERS,
    payload: { data, type, callback },
  }
}

// edit Survey
export const editSurvey = (data, id, callback) => {
  return {
    type: EDIT_SURVEY,
    payload: { data, id, callback },
  }
}

// mail invite
export const mailInviteSurvey = (data, callback) => {
  return {
    type: MAIL_INVITE,
    payload: { data, callback },
  }
}


// list Survey
export const listSurvey = (type, callback) => {
  return {
    type: LIST_SURVEY,
    payload: { type, callback },
  }
}

// Get question
export const getQuestion = (id, type, callback) => {
  return {
    type: GET_QUESTION,
    payload: { id, type, callback },
  }
}

export const getQuestionError = (id, type, callback) => {
  return {
    type: QUESTION_ERROR,
    payload: { id, type, callback },
  }
}

export const getQuestionSuccess = (id, type, callback) => {
  return {
    type: QUESTION_SUCCESS,
    payload: { id, type, callback },
  }
}

export const surveySuccess = message => {
  return {
    type: SURVEY_SUCCESS,
    payload: message,
  }
}

export const surveyError = message => {
  return {
    type: SURVEY_ERROR,
    payload: message,
  }
}

export const horizontalList = (type, callback) => {
  return {
    type: LIST_HORIZONTAL,
    payload: { type, callback },
  }
}


export const horizontalSuccess = message => {
  return {
    type: HORIZONTAL_SUCCESS,
    payload: message,
  }
}

export const horizontalError = message => {
  return {
    type: HORIZONTAL_ERROR,
    payload: message,
  }
}


export const verticalList = (type, callback) => {
  return {
    type: LIST_VERTICAL,
    payload: { type, callback },
  }
}


export const verticalSuccess = message => {
  return {
    type: VERTICAL_SUCCESS,
    payload: message,
  }
}

export const verticalError = message => {
  return {
    type: VERTICAL_ERROR,
    payload: message,
  }
}



